//Generated File 
export default class OwnerType{
	static readonly Entity = `Entity`;
	static readonly Other = `Other`;
}
